module.exports = __webpack_public_path__ + "static/img/苹果 iPhone 16 Pro Max.ec2d567d.png";